const LOCAL_CONFIG = {"REACT_APP_USER_POOL_ID":"us-west-2_u2okVmzS0",
    "REACT_APP_USER_POOL_WEB_CLIENT_ID":"3r2vs9qejuojpjph7r2vfg0dee",
    "REACT_APP_COGNITO_DOMAIN":"cog-approvermatrix-na-dev.auth.us-west-2.amazoncognito.com",
    "REACT_APP_REDIRECT_URL":"http://localhost:3000",
    "REACT_APP_API_ENDPOINT":"https://hbwdzuwyz9.execute-api.us-west-2.amazonaws.com/Alpha"}

export default LOCAL_CONFIG
